<template>
  <transition name="fade">
    <div
      class="have-curtain fixed overflow-y-auto h-full w-full flex flex-col items-center p-0 py-0 xl:py-24"
      style="z-index: 1000;"
    >
      <div @click="this.closeModal" class="curtain fixed inset-0 z-0 opacity-50"></div>
      <div class="w-full sm:w-5/6 xl:max-w-2xl mx-auto sm:my-12 lg:p-b-12 relative">
        <div
          class="modal-root bg-white relative product-modal rounded-full overflow-hidden transition-all duration-100 ease-in-out"
          style="min-height: 350px;"
        >
          <div
            class="absolute inset-0 bg-white z-50 flex items-center justify-center"
            v-if="loading"
          >
            <div class="flex flex-col items-center justify-center">
              <img alt="Cargando..." src="@/assets/loading.svg" />
              <div class="text-2xl text-cool-gray-400 font-medium">Cargando datos...</div>
            </div>
          </div>
          <div v-else>
            <slot>Modal Content</slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('modal-closed');
    },
  },
};
</script>

<style scoped>
.modal-root {
  @apply rounded-none;
  box-shadow: 0 0 150px rgba(0, 0, 0, 0.4);
}

@screen sm {
  .modal-root {
    border-radius: 15px;
  }
}

.modal-open {
  @apply fixed overflow-y-hidden w-full h-full;
}

.have-curtain {
  transition: all 0.2 ease-in;
  &:before {
    content: '';
    @apply fixed h-screen w-full inset-0;
    background-color: rgba(230, 230, 230, 0.75);
  }
}
</style>
